import 'css-chunksrc/client/scenes/project/projectToolsConfiguration/toggleInput/styles.scss';export default {
  "toggleInput": "_toggleInput_1klgt_1",
  "bar": "_bar_1klgt_9",
  "toggled": "_toggled_1klgt_31"
};